<div class="container">
  <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>
  <ul class="breadcrumb">
    <li><strong>Onde estou:</strong></li>
    <li class="active">
      <span>Cadastros/Usuários/<b>Macros</b></span>
    </li>
  </ul>


  <mat-accordion>
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Filtrar Macros
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row" [formGroup]="filterForm">

        <div class="col-2">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Código da Macro</mat-label>
            <input type="text" formControlName="codigoRede" autocomplete="off" matInput />
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nome da Macro</mat-label>
            <input formControlName="nomeRede" autocomplete="off" matInput />
          </mat-form-field>
        </div>
        <div class="col-4 btns-busca">
          <button mat-flat-button color="accent" (click)="applyFilter()" type="button">Consultar
            <mat-icon>search</mat-icon>
          </button>

          <button mat-flat-button (click)="filterForm.reset();  applyFilter()" type="button">Limpar
            Filtro
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="row mt-2 mb-2">
    <div class="col d-flex justify-content-end gap-2">
      <button color="accent" mat-flat-button type="button" (click)="criarNovaMaster()">
        <mat-icon>add</mat-icon>
        Criar Macro
      </button>
      <button mat-flat-button type="button" (click)="exportToExcel()">
        <mat-icon>description</mat-icon>
        <span> Exportar Excel</span>
      </button>
      <button mat-flat-button type="button" color="warn" (click)="openLogDialog()" matTooltip="Logs de auditoria de Macros"
        matTooltipPosition="above" aria-label="Logs de auditoria de Macros">
        <mat-icon>emergency</mat-icon>
      </button>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="w-100">


    <ng-container matColumnDef="expandir">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let macroPosto">
        <button mat-icon-button (click)="expandirPostos(macroPosto)" matTooltip="Expandir postos da Macro"
          matTooltipPosition="right" aria-label="Expandir postos da Macro" aria-hidden="false">
          <mat-icon matBadgeSize="small" matBadge={{macroPosto.qtdPostos}}
            matBadgeColor="accent">local_gas_station</mat-icon>

        </button>
        <button mat-icon-button (click)="expandirUsuarios(macroPosto)" matTooltip="Expandir usuários da Macro"
          matTooltipPosition="right" aria-label="Expandir usuários da Macro" aria-hidden="false">
          <mat-icon matBadge={{macroPosto.qtdUsuarios}} matBadgeColor="accent" matBadgeSize="small">person</mat-icon>

        </button>


      </td>
    </ng-container>

    <!-- CNPJ Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Código da Macro </th>
      <td mat-cell *matCellDef="let macroPosto"> {{macroPosto.idAdmRedePosto}} </td>
    </ng-container>


    <!-- Nome Column -->
    <ng-container matColumnDef="nome">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome da Macro</th>
      <td mat-cell *matCellDef="let macroPosto"> {{macroPosto.nome}} </td>
    </ng-container>

    <!-- Ações Column -->
    <ng-container matColumnDef="acoes">
      <th mat-header-cell *matHeaderCellDef> Ações </th>
      <td mat-cell *matCellDef="let macroPosto">
        <button mat-icon-button (click)="editarMacroPosto(macroPosto)" matTooltip="Editar Macro"
          matTooltipPosition="left" aria-label="Editar Macro" aria-hidden="false">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>


    <ng-container matColumnDef="detail">
      <td mat-cell *matCellDef="let master" [attr.colspan]="4">

        <div *ngIf="master.expandidoUsuarios">
          <app-tabela-usuarios
            [admRedeselecionado]="selectedMaster"
            (totalUsuariosChange)="atualizarQtdUsuarios($event)"
            (novoUsuarioCriado)="onNovoUsuarioCriado()"
            (removerUsuario)="onRemoverUsuario()">
          </app-tabela-usuarios>
        </div>

        <div *ngIf="master.expandidoPostos">
          <app-tabela-postos
            [admRedePosto]="master"
            (totalPostosAtreladosChange)="atualizarQtdPostos($event)">
          </app-tabela-postos>
        </div>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['expandir', 'id','nome',  'acoes']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandir', 'id','nome','acoes'];" class="info-normal"></tr>
    <tr mat-row *matRowDef="let row; columns: ['detail']" class="info-expandida"></tr>
    <!-- Row Detail Template -->

  </table>

  <mat-paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons></mat-paginator>

  <div class="row mt-4">
    <div class="col text-end">
      <button color="accent" mat-flat-button (click)="scrollToTopAnimated()" matTooltip="Ir para o topo da página"
        matTooltipPosition="above" aria-label="Ir para o topo da página" aria-hidden="false" type="button">
        <mat-icon>vertical_align_top</mat-icon>
        Ir para o topo
      </button>
    </div>
  </div>

</div>